import { useParams } from "react-router-dom";
import ConsentForm from "./ConsentForm";
import { useQuery } from "../../../../../../utils/hooks";

const RegistryConsentForm = () => {
  const { participantId, consentId } = useParams();
  const formId = useQuery().get("versionId");
  return (
    <ConsentForm
      participantId={participantId || ""}
      consentId={consentId || ""}
      formId={formId || ""}
      type="platform"
    />
  );
};

export default RegistryConsentForm;
